module.exports = __webpack_public_path__ + "static/media/ExtensionSuccess.fe469959.svg";